import React, { type FC } from "react";
import type { DfDocumentType } from "../../../../../shared-logic/utils/dfConstants";
import { useUscLabel } from "../../../../utils/labels";
import { useUscSelector } from "../../../../redux/store";
import type { FullQuickSpecConfigType } from "../../../../../shared-logic/utils/uscUtils";
import { getUscDocumentSpecImageUrl } from "../../../../../shared-logic/utils/uscSpecUtils";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import Icon from "../../../../../shared-components/toyota/styles/atoms/Icon";
import { SrOnly } from "../../../../../shared-components/toyota/styles/utils/Accessibility.styles";

type Props = { spec: FullQuickSpecConfigType };

const DocumentExtraSpec: FC<Props> = ({ spec }) => {
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const downloadDocumentLabel = useUscLabel("uscPdpDownloadDocument");

    const documentImage = getUscDocumentSpecImageUrl(spec.valueCode as DfDocumentType, commonSettings);

    return (
        <span>
            {documentImage ? (
                <Button variant="icon-text" href={spec.value}>
                    <img src={documentImage} alt={downloadDocumentLabel} width={100} />
                    <SrOnly>{downloadDocumentLabel}</SrOnly>
                </Button>
            ) : (
                <Button variant="icon-text" href={spec.value}>
                    <Icon variant="download" />
                    <span>{downloadDocumentLabel}</span>
                </Button>
            )}
        </span>
    );
};

export default DocumentExtraSpec;
